<template>
  <router-view />
</template>

<style lang="less">
@import "./main.less";
</style>
